import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();

  const token = localStorage.getItem('token');

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('farmer');
    navigate('/');
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-success shadow">
      <div className="container">
        <Link className="navbar-brand fw-bold fs-4" to="/">
          🌿 SURAJ AI
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#nav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="nav">
          <div className="ms-auto">

            {/* Logged in */}
            {token ? (
              <button
                onClick={handleLogout}
                className="btn btn-warning"
              >
                Logout
              </button>
            ) : (
              <>
                {/* Login Page */}
                {location.pathname === '/' && (
                  <Link to="/register" className="btn btn-warning">
                    Register
                  </Link>
                )}

                {/* Register Page */}
                {location.pathname === '/register' && (
                  <Link to="/" className="btn btn-light">
                    Login
                  </Link>
                )}
              </>
            )}

          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;